export const goalMaps: Record<string, string | null> = {
  retirement: 'retirement',
  car: 'a car',
  other: null,
}

export const goalMapsA: Record<string, string> = {
  retirement: '',
  car: '',
}

export const goalMapsB: Record<string, string> = {
  retirement: '',
  car: '',
}
